<template>
  <div>
    <div id="wrapper">
      <!------------sidebar Section  start----------->
      <a href="#sidebar" class="mobilemenu"><i class="icon-reorder"></i></a>

      <div id="sidebar">
        <div id="main-nav">
          <div id="nav-container">
            <!------------Profile Section sidebar start----------->

            <div id="profile" class="clearfix">
              <div class="portrate hidden-xs"></div>
              <div class="title">
                <h2>Md Abdul Karim</h2>
                <h3>StylZmedia Ltd.</h3>
              </div>

            </div>
            <!------------Profile Section sidebar end----------->
            <ul id="navigation">

              <!------------Biography Section----------->
              <li>
                <a href="#biography">
                  <div class="icon icon-user"></div>
                  <div class="text">About Me</div>
                </a>
              </li>
              <!------------Research Section----------->
              <li>
                <a href="#research">
                  <div class="icon icon-book"></div>
                  <div class="text">Research & Projects</div>
                </a>
              </li>
              <!------------Publication Section----------->
              <li>
                <a href="#publications">
                  <div class="icon icon-edit"></div>
                  <div class="text">Publications</div>
                </a>
              </li>
              <!------------Teaching Section end----------->
              <li>
                <a href="#teaching">
                  <div class="icon icon-time"></div>
                  <div class="text">Job History</div>
                </a>
              </li>
              <!------------Galary Section ----------->
              <li>
                <a href="#gallery">
                  <div class="icon icon-picture"></div>
                  <div class="text">Gallery</div>
                </a>
              </li>
              <!------------Contact Section start----------->
              <li>
                <a href="#contact">
                  <div class="icon icon-calendar"></div>
                  <div class="text">Contact & Meet Me</div>
                </a>
              </li>
              <!------------Contact Section end----------->
              <!------------CV Section start----------->
              <li class="external">
                <a href="#">
                  <div class="icon icon-download-alt"></div>
                  <div class="text"><a :href="'/md_abdul_karim.pdf'" target="_blank">Download CV</a></div>
                </a>
              </li>
              <!------------CV Section end----------->
            </ul>
          </div>
        </div>

        <!------------Social Section start----------->
        <div class="social-icons">
          <ul>
            <li><a :href="'http://facebook.com/ab.karim007'" target="_blank"><i class="icon-facebook"></i></a></li>
            <li><a :href="'https://twitter.com/abkarim007'" target="_blank"><i class="icon-twitter"></i></a></li>
            <li><a :href="'https://www.linkedin.com/in/md-abdul-karim-371190190'" target="_blank"><i class="icon-linkedin"></i></a></li>
            <li><a :href="'https://github.com/karim-007'" target="_blank"><i class="icon-github"></i></a></li>
            <li><a :href="'https://www.researchgate.net/profile/Md-Abdul-Karim-4'" target="_blank"><i class="glyphicon-bullhorn"></i>
            </a></li>
          </ul>
        </div>
        <!------------Social Section end----------->
      </div>
      <!------------Sidebar Section end----------->
    </div>

  </div>

</template>
<script>

export default {
  name: 'SideBar',

}
</script>
<style>
.fontawesomeicon::before {
  display: inline-block;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}

.Researchgate::before {
  font: var(--fa-font-brands);
  content: '\f4f8';
}</style>
